import { create } from 'zustand';
import { ApiError } from '@/src/types/api.types';

interface ErrorState {
  errors: Map<string, ApiError>;
  globalError: ApiError | null;
  
  setError: (key: string, error: ApiError) => void;
  setGlobalError: (error: ApiError | null) => void;
  clearError: (key?: string) => void;
  getError: (key: string) => ApiError | undefined;
  hasError: () => boolean;
}

export const useErrorStore = create<ErrorState>((set, get) => ({
  errors: new Map(),
  globalError: null,

  setError: (key: string, error: ApiError) => {
    set((state) => ({
      errors: new Map(state.errors).set(key, error),
    }));
  },

  setGlobalError: (error: ApiError | null) => {
    set({ globalError: error });
  },

  clearError: (key?: string) => {
    if (!key) {
      set({ errors: new Map(), globalError: null });
    } else {
      set((state) => {
        const newErrors = new Map(state.errors);
        newErrors.delete(key);
        return { errors: newErrors };
      });
    }
  },

  getError: (key: string) => {
    return get().errors.get(key);
  },

  hasError: () => {
    return get().errors.size > 0 || get().globalError !== null;
  },
}));
